import React, { useEffect } from "react";
import {
  Box,
  ColumnLayout,
  Container,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import { Link, useSearchParams } from "react-router-dom";
import Page from "components/page";
import PermissionBoundary from "components/permission-boundary";
import { useBreadcrumbs } from "features/breadcrumbs/hooks";
import { DATA_TYPES } from "./dataTypes";

const DataTypeSelection: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { updateBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    updateBreadcrumbs([
      { text: "Gaia", href: "/" },
      { text: "Data and insights", href: "/data-insights" },
      { text: "Select data type", href: "/data-insights/new" },
    ]);
  }, []);

  const buildHref = (path: string): string => {
    const query = searchParams.toString();
    return query ? `${path}?${query}` : path;
  };

  return (
    <PermissionBoundary allowMemberOnly={true}>
      <Page
        type="page"
        title="Select data type"
        description="What type of data do you need?"
        hasBreadcrumbs={true}
        hasInfo={false}
      >
        <ColumnLayout columns={2}>
          {DATA_TYPES.map((dataType) => (
            <Container key={dataType.id}>
              <SpaceBetween size="l">
                <div>
                  <Box fontSize="heading-s" fontWeight="bold">
                    <Link to={buildHref(dataType.path)}>{dataType.name}</Link>
                  </Box>
                  <div>{dataType.description}</div>
                </div>
                <div>
                  <Box variant="awsui-key-label">Input</Box>
                  <div>{dataType.input}</div>
                </div>
                <div>
                  <Box variant="awsui-key-label">Output</Box>
                  <div>{dataType.output}</div>
                </div>
              </SpaceBetween>
            </Container>
          ))}
        </ColumnLayout>
      </Page>
    </PermissionBoundary>
  );
};

export default DataTypeSelection;
